document.addEventListener('DOMContentLoaded', function() {
function custom_opt_btn(){
 jQuery('.product-opt-select').on('change', function () {
    var parentDiv = jQuery(this).closest('.product-options-container');
    var variantjson = JSON.parse(jQuery(parentDiv).find('script[type="application/json"]').html());
    var opts = [];
    
    jQuery(parentDiv).find('.product-opt-select').each(function () {
        opts.push(jQuery(this).val());
    });

    var selectedVar = variantjson.filter(function (v) {
        return v.option1 == opts[0] && v.option2 == opts[1] && v.option3 == opts[2];
    });

    var submitButton = jQuery(parentDiv).find('.product-form__cart-submit');
    var addToCartText = submitButton.find('span[data-add-to-cart-text]');
    
    if (selectedVar[0] === undefined || selectedVar[0].available == false) {
        submitButton.attr('disabled', 'true');
        addToCartText.text('Sold out');
    } else {
        submitButton.removeAttr('disabled');
        addToCartText.text('Add to cart');
    }

    jQuery(parentDiv).find('.product-form__variants select').val(selectedVar[0].id).trigger('change');
});
/*jQuery('.product-opt-accordion-btn').click(function() {
  jQuery(this).toggleClass('active');
  jQuery(this).next().toggleClass('active'); 
});*/

function customAddToCart(event){
    event.preventDefault();  

    let form = event.target.closest('form');
    if (!form) return;
    let formData = new FormData(form);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json()) 
    .then(data => {
        
        const GetCartJson = () => {
            return fetch('/cart.js').then((res) => res.json());
        }

     
        const RefreshCart = async () => {
            let cart = await GetCartJson();
            let isCartPage = document.querySelectorAll('.template-cart').length !== 0;

            if (isCartPage) {
                window.location.reload();
                return;
            }

          
            if (typeof window.r$1 !== 'undefined') {
                window.r$1("quick-cart:updated");
                window.r$1("cart:updated", { cart });
            }

           
               
                setTimeout(function () {

                    if (typeof window.r$1 !== 'undefined') {
                        window.r$1("quick-cart:open");
                    }

                   
                    let $quickModal = document.querySelector('.quick-product--wrap.modal.active');
                    if ($quickModal) {
                        $quickModal.querySelector('[data-modal-close]').dispatchEvent(new Event('click', {bubbles: true}));
                    }
                }, 400);
        }
        
   
        RefreshCart();

    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

if (!window.__addToCartCustomClickBound) {
    window.__addToCartCustomClickBound = true;
    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('data-add-to-cart-custom') || event.target.matches('span[data-add-to-cart-text]')) {
            customAddToCart(event);
        }
    });
}


}
custom_opt_btn()
});